module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_7_IAMS.640bb2683790827d52eb890301a26b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_7_IAMS.png
// module id = 784
// module chunks = 0